//import './navigation.js';
import './skip-link-focus-fix.js'
import './sliders.js'
import {initMap} from './map.js'

(( $ ) => {


	$(document).ready( () => {

		// header margin
		var header = $('.site-header');
		$("body").css('padding-top', $(header).height() + 'px');

		// tabs
		$('#tab-nav li:first-child').addClass('active');
		$('.tab-content').hide();
		$('.tab-content:first').show();

		$('#tab-nav li').click(function(){
		  $('#tab-nav li').removeClass('active');
		  $(this).addClass('active');
		  $('.tab-content').hide();

		  var activeTab = $(this).find('a').attr('href');
		  $(activeTab).fadeIn();
		  return false;
		});

		// sub-tabs
		$('#sub-tab-nav li:first-child').addClass('active');
		$('.sub-tab-content').hide();
		$('.sub-tab-content:first').show();

		$('#sub-tab-nav li').click(function(){
		  $('#sub-tab-nav li').removeClass('active');
		  $(this).addClass('active');
		  $('.sub-tab-content').hide();

		  var activeTab = $(this).find('a').attr('href');
		  $(activeTab).fadeIn();
		  return false;
		});

		// mobile menu
		$(".menu-toggle").click(function(){
			$("#site-navigation").toggleClass('active');
		});

		// search
		$(".search-toggle").click(function(){
		  $(".search-form-wrap").slideToggle(200);
			if($(this).attr('aria-expanded') == 'false') {
				$(this).attr('aria-expanded', true);
			} else {
				$(this).attr('aria-expanded', false);
			}
			if($('#collapseSearch').attr('aria-expanded') == 'false') {
				$('#collapseSearch').attr('aria-expanded', true);
			} else {
				$('#collapseSearch').attr('aria-expanded', false);
			}
		});

		// map init
    $('.shops-map').each(function(){
    	var map = initMap( $(this) );
    });

		// magazines layout toggle
		$(".show-list").click(function(){
			$(".show-list").addClass('hidden');
			$(".show-slider").removeClass('hidden');
			$(".magazine-slider").addClass('hidden');
			$(".slider-controls").addClass('hidden');
			$(".magazine-list").removeClass('hidden');
		});
		$(".show-slider").click(function(){
			$(".show-slider").addClass('hidden');
			$(".show-list").removeClass('hidden');
			$(".magazine-slider").removeClass('hidden');
			$(".slider-controls").removeClass('hidden');
			$(".magazine-list").addClass('hidden');
		});

		$('#magazine-year').on('change', function() {
		  $(".year-wrap").addClass('hidden');
			$(".year-" + this.value).removeClass('hidden');
		});

		// fixed header
		/*
		var header = $('.site-header');
    $(window).scroll(function () {
      if ($(this).scrollTop() > 1) {
				$("body").css('margin-top', $(header).height() + 'px');
        header.addClass("fixed-header");
      } else {
				$("body").css('margin-top', '0px');
        header.removeClass("fixed-header");
      }
    });
		*/

		// Youtube iframe wrap
		$('iframe[src*="youtube"]').wrap("<div class='youtube-iframe'></div>");

	});

	/* Ajax load more */
	$('.froggy-load-more').click(function(){
		var button = $(this),
		data = {
			'action': 'loadmore',
			'query': froggy_loadmore.posts,
			'page' : froggy_loadmore.current_page
		};

		$.ajax({
			url : froggy_loadmore.ajax_url,
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				button.text('Ladataan...');
			},
			success : function( data ){
				if( data ) {
					button.text('Lataa lisää').parent().before(data);
					froggy_loadmore.current_page++;
				if ( froggy_loadmore.current_page == froggy_loadmore.max_page )
					button.remove();
				} else {
					button.remove();
				}
			}
		});
	});


	/* Shop search */
	$('#shop_services').change(function(){
		var form = $('#shops-search');
    $.ajax({
      url:froggy_ajax_object.ajax_url,
      data: form.serialize() + '&loaded=0',
      type:form.attr('method'),
      success:function(data){
				$('#shop-search-content').html(data);
      }
    });
    return false;
	});
	$('#shops-search #keyword').keyup(function(){
		if( this.value.length < 4 ) return;
    var form = $('#shops-search');
    $.ajax({
      url:froggy_ajax_object.ajax_url,
      data: form.serialize() + '&loaded=0',
      type:form.attr('method'),
      success:function(data){
				$('#shop-search-content').html(data);
      }
    });
    return false;
  });
	$('#shops-search').submit(function(){
    var form = $('#shops-search');
    $.ajax({
      url:froggy_ajax_object.ajax_url,
      data: form.serialize() + '&loaded=0',
      type:form.attr('method'),
      success:function(data){
				$('#shop-search-content').html(data);
      }
    });
    return false;
  });


	/* optional triggers

	$(window).load(() => {

	});

	$(window).resize(() => {

	});

	*/


} )( jQuery );



// WEBPACK FOOTER //
// ./assets/js/app.js